import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledNewTag = styled.div`
  background-color: ${colorsPalettes.orange[400]};
  min-width: 31px;
  min-height: 16px;
  padding: 4px 5px 4px 5px;
  border-radius: 16px;
  text-transform: uppercase;
  ${setFontVariant('tag', colorsPalettes.carbon[0])};
  display: flex;
  justify-content: center;
`;
